import React from "react";
import Grid from "@material-ui/core/Grid";
import ArrowIcon from '@material-ui/icons/ChevronRight';
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import clsx from "clsx";
import Carousel from "../../../catalog/common/Carousel";

const useStyles = makeStyles(({ palette, ...theme }) => ({
  introWrapper: {
    position: "relative",
    height: "100%",
  },
  lightWhiteBG: {
    position: "absolute",
    display: "block",
    top: 0,
    bottom: 0,
    left: 0,
    right: "calc(50% - 95px)", // 1170*(1-5/7)
    [theme.breakpoints.down("xs")]: {
      right: 0,
    },
    background: "rgba(255,255,255,0.95)",
  },
  intro: {
    position: "relative",
    padding: "5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      padding: "2rem 0rem",
    },
    zIndex: 5,
  },
}));

const Intro5 = ({data}) => {
  const classes = useStyles();
  const imageList = ["random-1", "random-2", "random-3"];

  return (
    <Carousel slidesPerView={1} data={data.slider}>

    {data.slider.map((item, key) => <section className="section" id="intro5">
      <div key={key} className={classes.introWrapper} style={{background:
      "url("+item.image+") center center/cover no-repeat"}}>
        <div className="container">
          <Grid container spacing={0} alignItems="center">
            <Grid item sm={7} xs={12}>
              <div className={classes.intro}>
                <h1 className="font-bold text-48 mt-0">{item.title}</h1>
                {/* <p className="max-w-400 text-18 my-6">
                  Looking for a{" "}
                  <span className="text-primary">
                    world class graphics designer ?
                  </span>
                </p> */}
                <p className="max-w-400 mb-15">
{item.body}                </p>
                <p className="mb-6">PROJETS RECENTS</p>
                <div className="max-w-550 mb-6">
                  <Grid container spacing={3}>
                    {imageList.map((item, ind) => (
                      <Grid key={ind} item sm={4} xs={12}>
                        <div className="boder-radius-4">
                          <img
                            className="w-full"
                            src="https://via.placeholder.com/500"
                            alt={item}
                          />
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </div>
                <Button
                  className={clsx(
                    "rounded pl-6 pr-4 text-black mb-15",
                    classes.themeText
                  )}
                  variant="outlined"
                  color="primary"
                >
                  CLICK TO VIEW MORE{" "}
                  <ArrowIcon/>
                </Button>
              </div>
              <div className={classes.lightWhiteBG}></div>
            </Grid>
          </Grid>
        </div>
      </div>
    </section>)}
    </Carousel>

  );
};

export default Intro5;
